import { ActionTypes } from "../constants/action-types";

//scrollPos added to store background positon. Fix for OS-3642
const initialState = {
  drawerSection:"",
  scrollPos:0
};

export const drawerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SIGNIN_DRAWER:
      return {
        ...state,
        drawerSection: payload,
      };
    case ActionTypes.SET_SCROLL_POS:
      return {
        ...state,
        scrollPos: payload,
      };
    default:
      return state;
  }
};